function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "current",
  d: "M54,90.2c-.5,0-1.1-.2-1.5-.5-1.1-.8-1.3-2.4-.5-3.5,1-1.3,2-3.6,1.5-4.7-.4-.8-2.1-1.4-4.5-1.6-7.9-.5-10.6-4.8-11.6-7.4-1.4-3.8-.5-8.4,2.1-10.9,2.1-2,17.6-19.7,21.7-25.5,2.6-3.7,1.5-7-.4-11.2-.2-.5-.4-.9-.6-1.3-.5-1.3,0-2.7,1.3-3.3,1.3-.5,2.7,0,3.3,1.3.2.4.3.8.5,1.2,1.7,3.9,4.4,9.8,0,16.1-4.3,6.1-20,24-22.3,26.3-.9.9-1.7,3.2-.9,5.5.9,2.4,3.4,3.9,7.2,4.1,4.6.3,7.5,1.8,8.7,4.5,2,4.3-1.7,9.3-2.1,9.8-.5.7-1.2,1-2,1h0Z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fill: "current",
  d: "M52.4,66.7c5.3-.5,8.8,1.9,9.7,4.1s.9,3.6,0,4.3-2.4.9-3.2,0c-1.4-1.4.4-3.3-1.3-2.6s-4.9,0-6.3-1.2-1.5-2.9-.9-3.7,2-1,2-1Z"
});

var SvgIcoSimulationCategoryNose = function SvgIcoSimulationCategoryNose(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 0 110 110",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIcoSimulationCategoryNose, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ico_simulation_category_nose.d5c5d337.svg";
export { ForwardRef as ReactComponent };